export enum TranslationScopes {
	Account = 'account',
	User = 'user',
	FormularyNdc = 'formularyNdc',
	Customer = 'customer',
	Report = 'report',
	RebatesLoad = 'rebatesLoad',
	Payors = 'payors',
	RebateAggregator = 'rebateAggregator',
	RebatesUpdate = 'rebatesUpdate',
	RebatesReSubmission = 'rebatesReSubmission',
	LineOfBusiness = 'lineOfBusiness',
	Facility = 'facility',
	Bdc = 'bdc',
	CustomerMonthlyData = 'customerMonthlyData',
	NdcReplacementMappings = 'ndcReplacementMappings',
	DownstreamClientIdAssociation = 'downstreamClientIdAssociation',
	SubmissionPeriod = 'submissionPeriod',
	RebateAggregatorsNdcRates = 'rebateAggregatorNdcRate',
	AberrantQuantity = 'aberrantQuantity',
	UnbreakableQuantity = 'unbreakableQuantity',
	RebateGroup = 'rebateGroup',
	ExcludedPharmacy = 'excludedPharmacy',
	InOutpatientDefinition = 'inOutpatientDefinition',
	NonPatientExclusion = 'nonPatientExclusion',
	AuditEvents = 'auditEvents',
	ProcessingConfig = 'processingConfig',
	RebateGroupAggregatorNdc = 'rebateGroupAggregatorNdc',
	SubmissionOverview = 'submissionOverview',
	SubmissionFiles = 'submissionFiles'
}
